import { values } from '@fortem-monorepo/js-utilities';
export const ADMINISTRATOR = {
    Nt: 'nt',
    Link: 'link',
};
export const ADMINISTRATORS = values(ADMINISTRATOR);
